import React from 'react'

const Lights = ({ AmbientProps = {}, PointProps = {} }) => {
  return (
    <>
      <ambientLight
        color={0x7bb5e4}
        intensity={0.3}
        position={[100, 0, 100]}
        {...AmbientProps}
      />
      <pointLight
        color={0xffffff}
        intensity={1.25}
        position={[100, 200, 100]}
        castShadow
        {...PointProps}
      />
    </>
  )
}

export default Lights
